<p>booking-details works!</p>
